import type { ChangeEvent } from '@atlassian/jira-issue-view-model/src/change-type.tsx';

export const ISSUE_VIEW_UPDATE = 'state.actions.issue-view-update.ISSUE_VIEW_UPDATE';

export type IssueViewUpdateAction = {
	type: typeof ISSUE_VIEW_UPDATE;
	payload: ChangeEvent;
};

export const issueViewUpdate = (payload: ChangeEvent): IssueViewUpdateAction => ({
	type: ISSUE_VIEW_UPDATE,
	payload,
});

export type Action = IssueViewUpdateAction;
